var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.4 317.6C130.6 309.9 128 301.1 128 292L128 256C128 229.5 149.5 208 176 208L192 208L192 128C192 101.5 213.5 80 240 80C257.3 80 272.4 89.1 280.9 102.8C285.2 80.7 304.7 64 328 64C351.4 64 370.9 80.8 375.1 102.9C382.4 98.5 390.9 96 400 96C422.1 96 440.8 111 446.3 131.4C451.8 129.2 457.7 128 464 128C490.5 128 512 149.5 512 176L512 272.9C512 282.8 509.7 292.6 505.2 301.5L465.6 380.6C454.8 402.3 432.6 416 408.4 416L224 416C207.5 416 192.2 407.6 183.4 393.6L135.4 317.6zM160 544L160 496C160 478.3 174.3 464 192 464L448 464C465.7 464 480 478.3 480 496L480 544C480 561.7 465.7 576 448 576L192 576C174.3 576 160 561.7 160 544z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandBack);
export default __webpack_public_path__ + "static/media/hand-back.8947ddc38884301ad94a6fcd13a7b602.svg";
export { ForwardRef as ReactComponent };